import { render } from "./ShareTreePage.vue?vue&type=template&id=739d2f5f&scoped=true"
const script = {}

import "./ShareTreePage.vue?vue&type=style&index=0&id=739d2f5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739d2f5f"]])

export default __exports__